import { searchConfig } from "config";
import React, { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const useCategory = (
  scrollLoading,
  hasMore,
  setoffset,
  offset,
  categoryType,
  subCategory
) => {
  const { source } = useParams();

  const getOffset = () => {
    if (source === "peer-reviewed") return searchConfig.peerReviewed.offset;
    return searchConfig.categories.offset;
  };

  const dataCount = (academiaSearch) => {
    return academiaSearch === "Academia" || academiaSearch === "Bing" ? 21 : 10;
  };

  const observer = useRef();

  const lastElementRef = useCallback(
    (node) => {
      if (scrollLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            if (subCategory) {
              setoffset((prevOffset) => prevOffset + searchConfig.academia.offset);
            } else if (categoryType === "books") {
              setoffset((prevOffset) => prevOffset + searchConfig.books.offset);
            } else if (categoryType === "wiki") {
              setoffset((prevOffset) => prevOffset + searchConfig.wiki.offset);
            } else {
              setoffset(
                (prevOffset) =>
                  prevOffset + getOffset()
              );
            }
          }
        },
        {
          threshold: 0.1,
          rootMargin: '100px 0px 0px 0px'
        }
      );
      if (node && hasMore) {
        observer.current.observe(node);
      }
    },
    [scrollLoading, hasMore, subCategory, categoryType, setoffset]
  );

  return { lastElementRef, dataCount, setoffset, offset };
};

export default useCategory;
